import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck, Inject, OnDestroy  } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent, DwMetaDataGridActionState,
         DwDateTimeInputOptions, DwOrmDataServiceToken, DwOrmDataService, DwGridEvents,
         DwMetaDataFormApi, DwEventService, DwMdEventService, DwGridEvent, DwEvent, DwMdLoadEventData, DwGridDeleteActionService,
         DwMdQueryEventData, DwMetaDataFilters, DwMetaDataFilter, DwActionPreference, DwMetaDataGridApi, DwMetaDataService, DwMetaDataServiceToken,
         DwFormActionConfig, DwInMemoryDataSource, DwFormContextMode, DwMetaDataFormStateService, DwGridActionResult } 
         from '@devwareapps/devware-cap';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { FleetMetaDataItemNames, FleetMetaDataLookups, MaintenanceEntity, ServiceTypeEntity, FleetVehicleEntity } 
         from '../meta-data/fleet-meta-data.service';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, Subscription, of } from 'rxjs';
import * as moment_ from 'moment';
import { FleetVehicleContextService } from '../data-contexts/vehicle-details-context.service';
const moment = moment_;

@DwComponent(
  {
    key: 'vehicle-auction-link',
    name: 'Link to Auction',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
  }
)
@Component({
  selector: 'vehicle-auction-link',
  template: `<a href="#" style="font-size: 0.825rem" target="_blank" [routerLink]="['/fleet/vehicle-auction/edit/' + aid]">'{{uid}}' Auction Log</a> `
})
export class AddAuctionLinkComponent  {
    uid: string = '';    
    aid : number = null;
    formApi : DwMetaDataFormApi;
    vehicle : FleetVehicleEntity;
    subscriptions: Subscription[] = [];

    constructor(private dwSecurityUserService: DwSecurityUserService,
            private dwGridDeleteActionService : DwGridDeleteActionService,
            @Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
            @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
            private dwEventService: DwEventService,
            private dwFormStateService: DwMetaDataFormStateService) 
    {
        this.formApi = dwFormStateService.state.formApi;

        this.subscriptions.push(
            this.dwFormStateService.state.context['FleetVehicleContext'].subscribe(cxt => {
                if (cxt.AuctionId){
                    this.aid = this.aid ?? cxt.AuctionId;
                    for(const subscription of this.subscriptions) subscription.unsubscribe();
                }
            }));
        this.vehicle = this.formApi.getFormData(); 
        this.uid = this.vehicle.UnitId;
    }
}
